var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolBlueBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#0f4066",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.477587, -0.000000000000000355, 0.000000000000000355, 0.477587, 168.876322, 90.627042)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00276853 5.500289 L 120.516943 5.500289 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.477587, -0.000000000000000355, 0.000000000000000355, 0.477587, 168.876322, 90.627042)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 156.267989 5.500289 C 156.267989 14.611858 148.874042 21.997626 139.762473 21.997626 C 130.650905 21.997626 123.265136 14.611858 123.265136 5.500289 C 123.265136 -3.611279 130.650905 -10.997048 139.762473 -10.997048 C 148.874042 -10.997048 156.267989 -3.611279 156.267989 5.500289 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.238793, 0.413602, -0.413602, -0.238793, 173.296546, 93.166803)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00518844 5.498878 L 123.925104 5.498949 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.238793, 0.413602, -0.413602, -0.238793, 173.296546, 93.166803)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 159.671292 5.497031 C 159.672305 14.610354 152.285102 22.001475 143.17178 22.002488 C 134.058457 22.0035 126.67442 14.612208 126.673407 5.498886 C 126.672394 -3.614437 134.063686 -10.998475 143.177009 -10.999487 C 152.283248 -10.996411 159.674369 -3.609208 159.671292 5.497031 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.477575, -0.00334955, 0.00334955, -0.477575, 261.693151, 128.637824)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00132258 5.498827 L 123.926595 5.496666 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.477575, -0.00334955, 0.00334955, -0.477575, 261.693151, 128.637824)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 159.670362 5.499531 C 159.677014 14.611277 152.28563 21.999992 143.173827 21.998465 C 134.062023 21.996937 126.673365 14.613732 126.674893 5.501929 C 126.676421 -3.609875 134.059625 -10.998532 143.171429 -10.997005 C 152.283175 -11.003656 159.67189 -3.612272 159.670362 5.499531 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.235887, 0.415267, -0.415267, 0.235887, 261.96693, 123.699616)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000984295 5.497924 L 120.513694 5.502782 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.235887, 0.415267, -0.415267, 0.235887, 261.96693, 123.699616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 156.260662 5.4995 C 156.264735 14.616814 148.873718 21.99798 139.767555 21.99898 C 130.65024 22.003053 123.269075 14.612036 123.260962 5.501833 C 123.264001 -3.611442 130.651946 -11.003759 139.765221 -11.00072 C 148.878496 -10.997681 156.263701 -3.613775 156.260662 5.4995 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.243089, -0.411092, 0.411092, -0.243089, 275.830914, 220.616162)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00134359 5.505248 L 123.920835 5.501567 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.243089, -0.411092, 0.411092, -0.243089, 275.830914, 220.616162)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 159.669662 5.498518 C 159.67613 14.614888 152.287486 21.999932 143.175279 21.99936 C 134.063072 21.998788 126.673865 14.617184 126.674437 5.504977 C 126.667968 -3.611393 134.060775 -11.003477 143.172982 -11.002905 C 152.285189 -11.002333 159.670234 -3.61369 159.669662 5.498518 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.234471, 0.416067, -0.416067, -0.234471, 280.441304, 218.197046)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00158931 5.502312 L 120.517874 5.500962 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.234471, 0.416067, -0.416067, -0.234471, 280.441304, 218.197046)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 156.269425 5.501189 C 156.26683 14.6095 148.876607 22.003847 139.768296 22.001252 C 130.652859 22.002672 123.265638 14.608434 123.268233 5.500123 C 123.266812 -3.615314 130.653925 -10.99852 139.762236 -10.995925 C 148.877673 -10.997345 156.268004 -3.614248 156.269425 5.501189 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.237467, 0.414365, -0.414365, 0.237467, 99.170367, 153.666933)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00138818 5.500975 L 123.927782 5.49944 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.237467, 0.414365, -0.414365, 0.237467, 99.170367, 153.666933)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 159.674667 5.500439 C 159.673433 14.615711 152.285769 21.9961 143.177594 21.998933 C 134.062322 21.9977 126.67077 14.613065 126.672003 5.497793 C 126.66917 -3.610382 134.060901 -10.997867 143.169076 -11.000701 C 152.284348 -10.999467 159.6759 -3.614833 159.674667 5.500439 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.240117, -0.412835, 0.412835, 0.240117, 94.69261, 156.280024)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000113121 5.503912 L 120.516885 5.50228 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.240117, -0.412835, 0.412835, 0.240117, 94.69261, 156.280024)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 156.26274 5.499445 C 156.263521 14.610914 148.876521 22.0015 139.765051 22.002281 C 130.653582 22.003061 123.262996 14.616061 123.269286 5.50048 C 123.268505 -3.610989 130.655505 -11.001575 139.766974 -11.002356 C 148.878443 -11.003137 156.261959 -3.612025 156.26274 5.499445 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.238793, -0.413602, 0.413602, 0.238793, 202.810333, 280.634893)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000915782 5.502446 L 123.918204 5.499524 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.238793, -0.413602, 0.413602, 0.238793, 202.810333, 280.634893)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 159.675565 5.5006 C 159.676578 14.613923 152.285285 21.99796 143.171963 21.998973 C 134.05864 21.999986 126.674603 14.608693 126.67359 5.495371 C 126.676667 -3.610868 134.063869 -11.001989 143.170109 -10.998913 C 152.283431 -10.999925 159.674552 -3.612723 159.675565 5.5006 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.477587, 0.000000000833546, -0.000000000833546, -0.477587, 207.03235, 283.431778)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00230346 5.500764 L 120.513836 5.500764 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.477587, 0.000000000833546, -0.000000000833546, -0.477587, 207.03235, 283.431778)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 156.264882 5.500764 C 156.264882 14.612332 148.879114 21.998101 139.767545 21.998101 C 130.647798 21.998101 123.262029 14.612332 123.262029 5.500764 C 123.262029 -3.610805 130.647798 -10.996573 139.767545 -10.996573 C 148.879114 -10.996573 156.264882 -3.610805 156.264882 5.500764 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.477586, -0.000576988, 0.000576988, 0.477586, 113.820487, 247.123784)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00117111 5.498938 L 123.923498 5.501428 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.477586, -0.000576988, 0.000576988, 0.477586, 113.820487, 247.123784)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 159.674568 5.503724 C 159.671739 14.615296 152.285222 22.000325 143.17365 21.997497 C 134.062069 22.002847 126.677039 14.61633 126.671699 5.496569 C 126.674528 -3.615003 134.061045 -11.000032 143.172617 -10.997203 C 152.284198 -11.002554 159.669228 -3.616036 159.674568 5.503724 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.239293, -0.413313, 0.413313, -0.239293, 113.577105, 252.347621)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000822702 5.50251 L 120.512358 5.497894 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.239293, -0.413313, 0.413313, -0.239293, 113.577105, 252.347621)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 156.264852 5.499411 C 156.264005 14.609745 148.878121 21.996209 139.763688 22.002441 C 130.653354 22.001594 123.26689 14.61571 123.260658 5.501278 C 123.265603 -3.616136 130.651487 -11.0026 139.761821 -11.001753 C 148.879234 -10.996808 156.265699 -3.610924 156.264852 5.499411 ",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolBlueBackground);
export default __webpack_public_path__ + "static/media/SymbolBlueBackground.1ac8ae2b96ee1a93b6e58f02ff11e4df.svg";
export { ForwardRef as ReactComponent };